import React, { useEffect, useReducer } from 'react';
import _toString from 'lodash/toString';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';
import ReactHelmet from 'react-helmet';
import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import settings from 'configs/settings';
import { AppLoader } from 'components/Loader';
import FontStyle from 'components/FontStyle';
import UBTProvider from 'components/UBTProvider';

import IVPRuleList from 'pages/IVPRuleList';
import GetStartedWithTM from 'pages/GetStartedWithTM';

import * as actions from './actions';
import { APP_STATE } from './contants';
import reducer from './reducer';

import './app.css';

const App = () => {
    const [state, dispatch] = useReducer(reducer, { appState: APP_STATE.INITIALIZING });

    useEffect(() => {
        const configureI18n = () => {
            i18next
                .use(XHR)
                .use(LanguageDetector)
                .use(initReactI18next)
                .init(settings.i18next, (err, t) => {
                    if (err) {
                        console.log(err);
                    } else if (i18next.language) {
                        // Update lang attribute
                        const html = document.querySelector('html');
                        html.setAttribute('lang', i18next.language);
                    }

                    const body = document.querySelector('body');
                    body.setAttribute('style', 'margin: 0;');

                    dispatch(actions.initSuccess());
                });
        };

        configureI18n();
    }, []);

    if (state.appState === APP_STATE.INITIALIZING) {
        return <AppLoader />;
    }

    return (
        <FontStyle>
            <ReactHelmet>
                <link rel="icon" href={process.env.NODE_ENV === 'development' ? 'public/favicon.ico' : 'favicon.ico'} />
            </ReactHelmet>

            <UBTProvider>
                <Router basename={_toString(process.env.PUBLIC_URL)}>
                    <Switch>
                        <Route path="/ivp-rule-list" component={IVPRuleList} />
                        <Route path="/getting-started" component={GetStartedWithTM} />
                        <Route component={AppLoader} />
                    </Switch>
                </Router>
            </UBTProvider>
        </FontStyle>
    );
};

export default App;
